
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ChatCommand } from '../services/ai-chat.service';
import { BuyercaddyDataAgentService } from '../services/buyercaddy-data-agent.service';
import { ContactsBuyercaddyDataAgentService } from '../services/contacts-buyercaddy-data-agent.service';
import { GeminiService } from '../services/gemini-service.service';
import { INSTRUCTIONS } from '../services/instructions.constants';


export interface EnrichmentConfig {
  promptPrefix: string;
  systemInstruction: string;
  fetchDataFn: (prompt: string) => Promise<any>;
  geminiFn: (systemInstruction: string, prompt: string) => Promise<any>;
}

@Injectable({
  providedIn: 'root'
})
export class ChatEnrichmentConfigService {
  constructor(
    private buyercaddyDataAgentService: BuyercaddyDataAgentService,
    private userProfileDataAgentService: ContactsBuyercaddyDataAgentService,
    private geminiService: GeminiService
  ) {}

  public readonly config: Partial<Record<ChatCommand, EnrichmentConfig>> = {
    [ChatCommand.AnalyzeTechStacks]: {
      promptPrefix: 'Analyze tech stacks for company ',
      systemInstruction: INSTRUCTIONS.systemInstructionCompanySoftwareAnalysis,
      fetchDataFn: (prompt) =>
        firstValueFrom(this.buyercaddyDataAgentService.fetchData(prompt, 25)),
      geminiFn: (sys, prompt) => this.geminiService.analyzePrompt(sys, prompt, false),
    },
    [ChatCommand.FindCustomers]: {
      promptPrefix: 'Find customers of products ',
      systemInstruction: INSTRUCTIONS.systemInstructionCompaniesUseProduct,
      fetchDataFn: (prompt) =>
        firstValueFrom(this.buyercaddyDataAgentService.fetchData(prompt, 25)),
      geminiFn: (sys, prompt) => this.geminiService.analyzePrompt(sys, prompt,false),
    },
    [ChatCommand.FindEmployees]: {
      promptPrefix: 'Find profiles of employees',
      systemInstruction: INSTRUCTIONS.systemIstructionEmployee,
      fetchDataFn: (prompt) =>
        firstValueFrom(this.userProfileDataAgentService.fetchData(prompt, 25)),
        geminiFn: (sys, prompt) => this.geminiService.analyzePrompt(sys, prompt,true),
    }
  };
}
